export const ratio = (part, whole) => (Number(whole) > 0 ? (Number(part) / Number(whole)) * 100 : 0);

export const formatPercent = (part, whole) => `${ratio(part, whole).toFixed(1)}%`;

export const formatCount = (value) => Number(value || 0).toLocaleString();

export const prettyUrl = (url) => url.replace(/^https?:\/\/(www\.)?/, "").replace(/\/$/, "");
